<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
<h1 mat-dialog-title>Architectures for {{ data.prgmCode }}</h1>
<div class="archTable-div">
  <mat-card appearance="outlined" class="default-padding">
    <div class="gfs-table">
      <mat-table id="mainTable" [dataSource]="dataSource" [hidden]="noData" matSort matSortActive="arch"
                 matSortDirection="asc" aria-label="Arch Table">

        <ng-container *ngFor="let header of archHeaders" [matColumnDef]="header.name">
          <mat-header-cell class="columnHeader" *matHeaderCellDef
                           id="{{header.name}}">
            {{ header.label }}
          </mat-header-cell>
          <div>
            <mat-cell *matCellDef="let element">
              {{ element[header.name] }}
            </mat-cell>
          </div>
        </ng-container>

        <ng-container matColumnDef="paginator" [sticky]="true">
          <mat-footer-cell *matFooterCellDef>
            <mat-paginator [pageSize]="pageSize"
                           [length]="tableLength"
                           [pageIndex]="pageIndex"
                           (page)="handlePage($event)"
                           showFirstLastButtons
                           aria-label="Select page">
            </mat-paginator>
          </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"
                 [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}"
                 (click)="selection.toggle(row)" (keydown)="selection.toggle(row)"
                 (mouseover)="row.hovered = true" (focus)="row.hovered = true"
                 (mouseout)="row.hovered = false" (blur)="row.hovered = false"></mat-row>
        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No Architectures for {{ data.prgmCode }}</td>
        </tr>
        <mat-footer-row class="paginated-footer" *matFooterRowDef="['paginator']; sticky: true"></mat-footer-row>
      </mat-table>
    </div>
  </mat-card>
</div>
<div class="button-container">
  <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" id="setSelectedArch-button" class="action-button"
          (click)="setSelectedArch(data.prgmCode, selection.selected[0].arch)" [disabled]="selection.isEmpty()">
    Set Selected Arch
  </button>
</div>

